import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"

import { PageContent } from "@/components/common/page-content"
import { PageHeader } from "@/components/common/page-header"
import { IssueActions } from "@/features/issues/components/issue-actions"
import { IssueHeading } from "@/features/issues/components/issue-heading"
import { IssueSummary } from "@/features/issues/components/issue-summary"
import { IssueTimeline } from "@/features/issues/components/issue-timeline"
import { issueQueries } from "@/queries/issues"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/issues/$issueId/"
)({
  component: IssuePage,
})

function IssuePage() {
  const { issueId } = Route.useParams()
  const { data: issue } = useSuspenseQuery(issueQueries.detail(issueId))

  return (
    <>
      <PageHeader
        title={issue.title}
        back={{ label: "Issues", to: "/$organisation/issues" }}
        actions={<IssueActions issue={issue} />}
      />
      <PageContent className="max-w-3xl gap-12 py-4">
        <div className="flex flex-col gap-4">
          <IssueHeading issue={issue} />
          <IssueSummary issue={issue} />
        </div>
        <IssueTimeline issue={issue} />
      </PageContent>
    </>
  )
}
